"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _DateTime = _interopRequireDefault(require("../../Tools/DateTime"));

var _EventHandler = _interopRequireDefault(require("../../Events/EventHandler"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class Status extends _EventHandler.default {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "paused", null);

    _defineProperty(this, "unit", null);

    _defineProperty(this, "interval", null);
  }

  static fromObject(obj) {
    let status = new Status();
    Object.keys(obj || {}).forEach(key => {
      let value = obj[key];

      switch (key) {
        case 'paused':
        case 'interval':
        case 'unit':
          status[key] = value;
      }
    });
    return status;
  }

  validate() {
    if (!this.paused || !this.unit || !this.interval) {
      return true;
    }

    if (new Date().getTime() < _DateTime.default.addTime(new Date(+this.paused), this.interval, +this.unit)) {
      throw new Error("Loja fechada");
    }
  }

}

exports.default = Status;